const initialDockPosition="center";
const autoHideDock = false

export const handleDockPosition=(state=initialDockPosition,action)=>{
    switch(action.type){
        case "moveDockToCenter" : return state="center"
        case "moveDockToLeft" : return state="left"
        case "moveDockToRight" : return state="right"
        default : return state;
    }
}

export const handleDockVisibility=(state=autoHideDock,action)=>{
    switch(action.type){
        case "disableAutoHideDock" : return state= false
        case "enableAutoHideDock" : return state=true
        default : return state;
    }
}